/* ============================================================
   Lost Collective · Article share triggers
   File: assets/lc-article-share.js

   Wires every [data-share] element: native Web Share API when
   available, otherwise clipboard.writeText with a textarea
   fallback. Shows a per-trigger "Link copied" pill for ~2s.
   ============================================================ */

(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') return fn();
    document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var triggers = document.querySelectorAll('[data-share]');
    if (!triggers.length) return;

    var hasNativeShare = 'share' in navigator && typeof navigator.share === 'function';

    document.querySelectorAll('[data-share-action="native"]').forEach(function (btn) {
      if (hasNativeShare) btn.removeAttribute('hidden');
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (ev) {
        ev.preventDefault();
        var action = trigger.getAttribute('data-share-action');
        var feedback = trigger.querySelector('.art-share__feedback');
        var title = document.title;
        var url = window.location.href;
        var text = (document.querySelector('meta[name="description"]') || {}).content || '';

        if (action === 'native' && hasNativeShare) {
          navigator.share({ title: title, text: text, url: url }).catch(function () {});
          return;
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(function () {
            showFeedback(trigger, feedback, 'Link copied');
          }).catch(function () {
            fallbackCopy(url);
            showFeedback(trigger, feedback, 'Link copied');
          });
        } else {
          fallbackCopy(url);
          showFeedback(trigger, feedback, 'Link copied');
        }
      });
    });

    function showFeedback(trigger, feedback, message) {
      if (feedback) {
        feedback.textContent = message;
        feedback.classList.add('is-visible');
        setTimeout(function () { feedback.classList.remove('is-visible'); }, 2000);
      } else {
        var label = trigger.querySelector('.art-share__btn-label, span') || trigger;
        var original = label.textContent;
        label.textContent = message;
        setTimeout(function () { label.textContent = original; }, 2000);
      }
    }

    function fallbackCopy(text) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try { document.execCommand('copy'); } catch (_e) {}
      document.body.removeChild(textarea);
    }
  });
})();
